import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkspaceMemberRole } from '@workspace/domain/workspace/vo/WorkspaceMemberRole';

type Props = {
  role: WorkspaceMemberRole;
  onChange(role: WorkspaceMemberRole): void;
  disabled: boolean;
  isGuest: boolean;
};

export const RoleSelect: React.FC<Props> = ({ role, disabled, onChange, isGuest }: Props) => {
  const { t } = useTranslation();
  const handleChangeRole = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      onChange(WorkspaceMemberRole.load(event.target.value));
    },
    [onChange]
  );

  return (
    <select
      className="form-select w-24 py-1 text-sm"
      defaultValue={role.toString()}
      onChange={handleChangeRole}
      disabled={disabled}
    >
      {WorkspaceMemberRole.values()
        .filter((role) => (isGuest ? role !== WorkspaceMemberRole.admin : true))
        .map((role) => (
          <option key={role} value={role}>
            {t(WorkspaceMemberRole.getLocalStringKey(role))}
          </option>
        ))}
    </select>
  );
};
